import { AddressDetailsModel } from '../client/client.model';

export class UpdateAdvisorDetailsRequest {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  officePhoneNumber: string;
  email: string;
  gpNumber: string;
  address: AddressDetailsModel = new AddressDetailsModel();
}
